import React from "react";
import { ClockCircleOutlined, InfoCircleOutlined, RetweetOutlined, CheckCircleOutlined } from "@ant-design/icons";

const ProjectConstants = new Object();


ProjectConstants.access_levels = {
  'quality_control': 'Quality Control',
  'owner': 'Owner (PM)',
  'co_owner': 'Co-Owner',
  'viewer': 'Viewer',
  'editor': 'Editor'
}

ProjectConstants.edit_access_levels = ['co_owner', 'owner', 'viewer', 'quality_control', 'editor'];

ProjectConstants.new_edit_access_levels = [
  {
    'label': 'Co-Owner',
    'value': 'co_owner'
  },
  {
    'label': 'Viewer',
    'value': 'viewer'
  },
  {
    'label': 'Quality Control',
    'value': 'quality_control'
  },
  {
    'label': 'Editor',
    'value': 'editor'
  }
]

ProjectConstants.access_actions = {
  'owner': ['invite', 'approve_project', 'delete_project', 'approve_entity', 'comment', 'create'],
  'co_owner': ['invite', 'approve_project', 'delete_project', 'approve_entity', 'comment', 'create'],
  'editor': ['invite', 'create', 'comment', 'approve_entity'],
  'quality_control': ['comment', 'approve_entity'],
  'viewer': [],
  'restricted': []
}


ProjectConstants.access_action_descriptions = {
  'owner': 'Owners can invite other users, approve a project, delete a project, approve models, add comments, create scenes',
  'co_owner': 'Co-owners can invite other users, approve a project, delete a project, approve models, add comments, create scenes',
  'editor': 'Editors can invite other users, approve models, add comments, create scenes',
  'quality_control': 'Quality Control can add comments, approve models',
  'viewer': 'Viewers can only view project items',
}

ProjectConstants.model_type_filters = [
  {
    label: "Product",
    value: "product",
  },
  {
    label: "Scenes",
    value: "scene",
  },
  {
    label: "Space",
    value: "room",
  },
  {
    label: "Prop",
    value: "prop",
  },
];

ProjectConstants.review_status_filters = [
  {
    label: "In Progress",
    value: "in_progress",
  },
  {
    label: "Ready for review",
    value: "in_review",
  },
  {
    label: "Approved and Completed",
    value: "approved",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
  {
    label: "Incomplete",
    value: "incomplete",
  },
];

ProjectConstants.model_type_filters = [
    {
      label: "Product",
      value: "product",
    },
    {
      label: "Scenes",
      value: "scene",
    },
    {
      label: "Space",
      value: "room",
    },
    {
      label: "Prop",
      value: "prop",
    },
  ];

  ProjectConstants.status_data = {
    rejected: {
      icon: <ClockCircleOutlined />,
      title: "ALL3D is Fixing",
    },
    approved: {
      icon: <CheckCircleOutlined style={{ color: "green" }} />,
      title: "Model Approved",
    },
    in_review: {
      icon: <CheckCircleOutlined style={{ color: "grey" }} />,
      title: "Ready for Review",
    },
    in_progress: {
      icon: <ClockCircleOutlined style={{ color: "green" }} />,
      title: "ALL3D is Creating",
    },
    incomplete: {
      icon: <InfoCircleOutlined style={{ color: "grey" }} />,
      title: "Model is Incomplete",
    },
  };

  ProjectConstants.scene_status_data = {
    in_progress: {
      icon: <ClockCircleOutlined style={{ color: "green" }} />,
      title: "Scene in Progress",
    },
    incomplete: {
      icon: <InfoCircleOutlined style={{ color: "grey" }} />,
      title: "Scene is Incomplete",
    },
    copy_in_progress: {
        icon: <InfoCircleOutlined style={{ color: "grey" }} />,
        title: "Copy in Progress",
    },
    approved: {
      icon: <CheckCircleOutlined style={{ color: "green" }} />,
      title: "Scene complete",
    }
  };

  ProjectConstants.entity_data = {
    product: {
      title: "Product",
      className: "product-tag",
      select_id: "id",
    },
    prop: {
      title: "Prop",
      className: "prop-tag",
      select_id: "id",
    },
    room: {
      title: "Space",
      className: "space-tag",
      select_id: "room_id",
    },
    scene: {
      title: "Scene",
      className: "scene-tag",
      select_id: "id"
    },
  };

  ProjectConstants.avatar_colors = [
    "#FFA39E", "#FFBB96", "#FFD591", "#FFE58F", "#B7EB8F", "#87E8DE", "#91D5FF"
    , "#ADC6FF", "#D3ADF7", "#FFADD2"
  ]

export default ProjectConstants;